import React from 'react';
//import PropTypes from 'prop-types';

import './rig-contracts-view.scss';
import ComingSoonComponent from '../../common/components/coming-soon/coming-soon-component';

const RigContractsView = (props) => {
  return (
    <div className="view-panel rig-contracts-view">
      <h1>RigContractsView</h1>
      <ComingSoonComponent />
    </div>
  );
};

RigContractsView.propTypes = {
}

export default RigContractsView;